const BUSINESS_PORTAL_PRODUCTION = "https://business.belyfted.com";
const BUSINESS_PORTAL_STAGING = "https://business-staging.belyfted.com";

const STAGING_HOST_PATTERN = /staging/i;

/** True when hostname looks like a staging deploy (e.g. belyfted247-staging.belyfted.com). */
export function isStagingHostname(hostname = "") {
  return STAGING_HOST_PATTERN.test(String(hostname).toLowerCase());
}

/**
 * Detect staging for client or server.
 * Priority: NEXT_PUBLIC_APP_ENV → NEXT_PUBLIC_API_URL → browser hostname → NODE_ENV.
 */
export function isStagingEnvironment() {
  const appEnv = process.env.NEXT_PUBLIC_APP_ENV;
  if (appEnv === "staging") return true;
  if (appEnv === "production" || appEnv === "live") return false;

  const apiUrl = process.env.NEXT_PUBLIC_API_URL || "";
  if (STAGING_HOST_PATTERN.test(apiUrl)) return true;

  if (typeof window !== "undefined") {
    return isStagingHostname(window.location.hostname);
  }

  return process.env.NODE_ENV !== "production";
}

/** Search engines should only index the live production site. */
export function isSearchIndexable() {
  return !isStagingEnvironment();
}

export function getRobotsMetadata() {
  if (isSearchIndexable()) {
    return { index: true, follow: true };
  }

  return {
    index: false,
    follow: false,
    nocache: true,
    googleBot: {
      index: false,
      follow: false,
      noimageindex: true,
    },
  };
}

/** Business BaaS portal origin (no trailing slash). */
export function getBusinessPortalBaseUrl() {
  const configured = process.env.NEXT_PUBLIC_BUSINESS_PORTAL_URL;
  if (configured) {
    return configured.replace(/\/$/, "");
  }

  return isStagingEnvironment()
    ? BUSINESS_PORTAL_STAGING
    : BUSINESS_PORTAL_PRODUCTION;
}

/** Where to send users who choose Business on consumer registration. */
export function getBusinessRegistrationUrl() {
  const base = getBusinessPortalBaseUrl();
  const path = isStagingEnvironment() ? "/login" : "/register";
  return `${base}${path}`;
}
